import { memo, useCallback, useMemo, useState } from 'react'
import { useShallow } from 'zustand/react/shallow'
import { useListenerMessage } from '../../../hooks/subscription/use-listener-message'
import { useSub } from '../../../hooks/subscription/use-sub'
import { useGlobalStore } from '../../../store/global-store'
import type {
  LiveGiftsAnimations,
  Positions,
} from '../../../types/lives/animations'
import { Animation } from './components/animation'

const LIVE_GIFTS_ANIMATIONS = '/LIVE-GIFTS-ANIMATIONS'

export const GiftsAnimations = memo(() => {
  const liveId = useGlobalStore(useShallow((state) => state.liveId))

  const [animation, setAnimation] = useState<LiveGiftsAnimations[]>([])

  const checkGiftReceived = useCallback(
    (liveGiftAnimation: LiveGiftsAnimations) => {
      const id = String(Date.now())

      setAnimation((prevState) =>
        prevState.concat({
          ...liveGiftAnimation,
          id,
        }),
      )
    },
    [],
  )

  const removeAnimation = useCallback((id: string) => {
    setAnimation((prevState) =>
      prevState.filter((animation) => animation.id !== id),
    )
  }, [])

  useSub<LiveGiftsAnimations>({
    endpoint: `${LIVE_GIFTS_ANIMATIONS}/${liveId}`,
    skip: !liveId,
    onData: checkGiftReceived,
  })

  const [positions, setPositions] = useState<Record<string, Positions> | null>(
    null,
  )

  const allPositions = useMemo(
    () => positions && Object.entries(positions),
    [positions],
  )

  useListenerMessage((data) => {
    const message = JSON.parse(data)
    setPositions((prevState) => ({ ...prevState, ...message }))
  })

  return (
    <div className="w-screen h-screen flex overflow-hidden">
      {animation.map((animation) => (
        <Animation
          key={animation.id}
          animation={animation}
          removeAnimation={removeAnimation}
        />
      ))}

      {allPositions?.map(([key, position]) => (
        <div
          id={key}
          key={key}
          className="absolute w-20 h-20 text-white text-xs"
          style={{ top: position?.y, left: position?.x }}
        />
      ))}
    </div>
  )
})
